import * as yup from 'yup';
import { EExtendedFieldTypes, EFormFieldsNames } from '../../../types/requestForm';
import { DEFAULT_ALLOWED_FILES_EXTENSIONS, DEFAULT_FILE_SIZE_LIMIT, DEFAULT_FILES_COUNT_LIMIT } from '../../../constants/file';
import { formatBytes } from '../../../utils/formatBytes';
var accept = DEFAULT_ALLOWED_FILES_EXTENSIONS;
var filesCountLimit = DEFAULT_FILES_COUNT_LIMIT;
var fileSizeLimit = DEFAULT_FILE_SIZE_LIMIT;
export var FILES_FIELD = {
  field: {
    name: EFormFieldsNames.Files,
    type: EExtendedFieldTypes.FileUploaderField,
    description: "\u041C\u043E\u0436\u043D\u043E \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0434\u043E ".concat(filesCountLimit, " \u0444\u0430\u0439\u043B\u043E\u0432 \u043F\u043E ").concat(formatBytes(fileSizeLimit), " \u043A\u0430\u0436\u0434\u044B\u0439"),
    fileUploader: {
      accept: accept,
      fileSizeLimit: fileSizeLimit,
      filesCountLimit: filesCountLimit
    }
  },
  validation: yup.array().of(yup.object({
    status: yup.string().oneOf(Array.of('succeed', 'failed', 'loading', 'initial')),
    uploadedFile: yup.string()
  })).test({
    message: 'Дождитесь окончания загрузки',
    test: function test(value) {
      return !(!!value && value.some(function (f) {
        return f.status === 'loading';
      }));
    }
  }).test({
    message: 'Не удалось загрузить файлы. Удалите или повторно загрузите их.',
    test: function test(value) {
      return !(!!value && value.some(function (f) {
        return f.status === 'failed';
      }));
    }
  }).required('Прикрепите файлы')
};